import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { DiscountEventTimer } from "../../discount-event/DiscountEventTimer";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { List } from "../../generic/list/List";
import { TextLoca } from "../../generic/text/TextLoca";
import { OfferHC } from "./OfferHC";
var renderOffers = function (offers) {
    return (React.createElement(List, { className: "offer-hc__list-container", items: offers, renderItem: function (offer, index) { return (React.createElement(OfferHC, { offer: offer, key: offer.shopPackage + "_" + offer.baseGoldValue, offerIndex: index })); } }));
};
export var OfferPageHC = function (_a) {
    var offers = _a.offers;
    if (offers == undefined || offers.length === 0) {
        // tslint:disable-next-line:no-null-keyword
        return null;
    }
    var _b = offers[0], backgroundColor = _b.backgroundColor, locaKeyTitle = _b.locaKeyTitle, remainingSeconds = _b.remainingSeconds, bonusGoldPercent = _b.bonusGoldPercent;
    var offerList = renderOffers(offers);
    var tintStyle = {
        backgroundColor: backgroundColor,
        border: "none",
        height: "100%",
        width: "100%",
    };
    var remainingTimeComponent;
    if (remainingSeconds && remainingSeconds > 0) {
        remainingTimeComponent = (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
            React.createElement(DiscountEventTimer, { endTime: remainingSeconds, discountAmount: bonusGoldPercent, idLoca: IdLoca.value_nominal_multiply })));
    }
    return (React.createElement("div", { className: "offer-container" },
        React.createElement("div", { className: IdStyles.OfferHeader + " wooden-texture-background offer-header-container" },
            React.createElement(TextLoca, { id: locaKeyTitle, className: "" + IdStyles.HeadlineOne })),
        React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-body__container" },
            React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-container__tint", style: tintStyle }),
            offerList),
        remainingTimeComponent));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferPageHC.tsx
// module id = 2917
// module chunks = 3